import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import authReducer from './authSlice';
import reviewsReducer from './reviewsSlice';
import productsReducer from './productsSlice';
import ordersReducer from './ordersSlice';
import settingsReducer from './settingsSlice';

export default configureStore({
    reducer: {
        auth: authReducer,
        reviews: reviewsReducer,
        products: productsReducer,
        orders: ordersReducer,
        settings: settingsReducer,
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false,
        // serializableCheck: {
        //     ignoredActions: [addFiles, setFiles]
        // }    
    }),
})
